var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaArribaPasivo24X24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5695 15.2986C19.3 15.6131 18.8265 15.6496 18.512 15.38L12.2888 10.0473C12.1207 9.90162 11.8793 9.90161 11.7112 10.0473L11.708 10.05L5.488 15.38C5.17347 15.6496 4.7 15.6131 4.43048 15.2986C4.16095 14.984 4.19744 14.5106 4.51197 14.241L10.7288 8.91377L10.7306 8.91219C11.4619 8.27996 12.5382 8.27998 13.2694 8.91224L19.488 14.241C19.8025 14.5106 19.839 14.984 19.5695 15.2986Z",
    fill: "#42C67E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaArribaPasivo24X24);
export default __webpack_public_path__ + "static/media/FLECHA_ARRIBA_PASIVO_24X24.151a27ca90187f120cd39fab1bab3f30.svg";
export { ForwardRef as ReactComponent };